import React, { useEffect, useRef } from 'react';

import { MapTo, Utils } from '@adobe/aem-react-editable-components';
import { useQuery } from '@apollo/client';
import { GET_INCIDENTS } from 'Queries/Queries';
import { useFormik } from 'formik';
import qs from 'query-string';
import { useLocation } from 'react-router-dom';

import { PageTitleSection } from 'components/PageTitleSection/PageTitleSection';
import { RenderAemComponent } from 'components/RenderAemComponent/RenderAemComponent';
import { ReportIncidentCard } from 'components/ReportIncidentCard/ReportIncidentCard';
import { ThemedTextField } from 'components/ThemedTextField/ThemedTextField';

import { TENANT_ID } from 'global/constants';

import { getTenantId, withTenant } from 'utils/tenantUtil';

import { EdisIncidentFormField } from './EdisIncidentFormField';
import { renderIncidents, renderIncidentsMobile } from './IncidentUtils';
import { YDisorderPage } from './YDisorderPage';

import './EdisIncidents.scss';

const EdisIncidents = () => {
  const { search, key } = useLocation();
  const reportFaultSection = useRef(null);

  const { loading, error, data, isFetching } = useQuery(GET_INCIDENTS);
  useEffect(() => {
    const parsedQS = qs.parse(search);
    if (!loading && parsedQS.toReport) {
      if (reportFaultSection) {
        reportFaultSection.current.scrollIntoView();
      }
    } else {
      window.scrollTo(0, 0);
    }
  }, [key, loading]);

  const formik = useFormik({
    initialValues: { zip: '' },
    validationSchema: YDisorderPage,
  });
  const isEditor = Utils.isInEditor();

  if (isEditor) {
    return <RenderAemComponent componentProps={{}} name="EdisIncident" />;
  }
  if (error) return <div>(!) ERROR (!)</div>;

  const { values, handleChange, handleBlur, touched, errors } = formik;

  if (loading) {
    return <PageTitleSection title="Lädt..." notFramed />;
  }
  if (data?.incidents?.length === 0) {
    return <PageTitleSection title="Momentan sind keine Störungen bekannt" notFramed />;
  }
  const renderTitleContent = (
    <div className="disorder-page-content-stage" data-testid={withTenant('edisIncidents')}>
      <div className="">
        <PageTitleSection
          title={getTenantId() === TENANT_ID.AVA ? 'Störungen' : 'Aktuelle Störungen'}
          subText=""
          notFramed
        />
      </div>
      <div className="disorder-panel">
        <EdisIncidentFormField>
          <ThemedTextField
            fullWidth
            id="zip"
            name="zip"
            label="Suche nach Postleitzahl"
            variant="standard"
            value={values.zip}
            onChange={handleChange}
            onBlur={handleBlur}
            error={touched.zip && Boolean(errors.zip)}
            helperText={touched.zip && errors.zip}
          />
        </EdisIncidentFormField>
        <div className=" hide-tablet hide-phone">{renderIncidents(data.incidents, values.zip)}</div>
        <div className=" hide-desktop">{renderIncidentsMobile(data.incidents, values.zip)}</div>
      </div>
    </div>
  );
  return (
    <div className="disorder-page-content">
      {renderTitleContent}
      <div className="disorder-page-report-incident-card-wrapper" ref={reportFaultSection}>
        <ReportIncidentCard />
      </div>
    </div>
  );
};

MapTo('e-fix/components/content/edisincidents')(EdisIncidents);
